<section class="app-top">
  <div class="app-top__con">
    <picture
      [appAnimate]="'landing'"
      [speed]="'fast'"
      [aos]="0.2"
      [once]="true"
    >
      <source srcset="assets/images/top/top.png" />
      <img
        [aos]="0.2"
        [appAnimate]="'landing'"
        [once]="true"
        [speed]="'fast'"
        alt="Kupuj produkty Foxy i wygrywaj CODZIENNIE"
        class="app-top__con--img"
        height="805"
        ngSrc="assets/images/top/top.avif"
        priority="true"
        width="1366"
      />
    </picture>

    <div class="row">
      <div class="col-12 text-center mb-3">
        <button
          class="app-top__con--btn app-btn app-btn--blue"
          [appAnimate]="'landing'"
          [speed]="'fast'"
          [aos]="0.2"
          [once]="true"
          (click)="navigationClick.emit(SectionType.LOTTERY_ENTRY)"
        >
          ZGŁASZAM SIĘ DO LOTERII
        </button>
      </div>
      <div class="col-12 text-center">
        <a
          class="app-top__con--a"
          [appAnimate]="'landing'"
          [speed]="'fast'"
          [aos]="0.2"
          [once]="true"
          href="https://www.foxy.eu/pl/nasze-produkty/"
          target="_blank"
        >
          WIĘCEJ O PRODUKTACH FOXY>
        </a>
      </div>
    </div>
  </div>
</section>
